<template>
  <div id="bottomPrice">
    <div class="title">{{ $t("ArgentinaPay.Amount") }}</div>
    <div class="text">
      <span>{{ symbol }}</span>
      <span id="num">{{ newPayAmount }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ChangeDomNum } from "@/utils/index";

export default {
  name: "NftPayAmount-bottom",
  //是否在首页
  scene: {
    type: String,
    default: null,
  },
  data() {
    return {
      // newPayAmount: 0,
    };
  },
  computed: {
    ...mapState("buyNftHome", {
      symbol: (state) => state.fiatCurrency.symbol,
      payAmount: (state) => state.payAmount,
      nftInfo: (state) => state.nftInfo,
    }),
    newPayAmount() {
      //数字变化动画
      return ChangeDomNum("num", {
        start: 0,
        end: this.payAmount ? this.payAmount : 0,
        duration: 500,
        timeStep: 50,
      });
    },
  },
  // watch: {
  //   'payAmount': {
  //     deep: true,
  //     immediate: true,
  //     handler(val,oldVal){
  //       let newOldVal = oldVal === undefined ? 0 : oldVal;
  //       console.log(newOldVal,'监控到到金额')
  //       // 数字变化动画
  //       ChangeDomNum(
  //           'num',
  //           {start: newOldVal, end: val, duration: 500, timeStep: 50}
  //       );
  //     }
  //   }
  // },
};
</script>

<style lang="scss" scoped>
#bottomPrice {
  display: flex;
  justify-content: right;
  align-items: center;
  margin-bottom: 0.28rem;
  .title {
    font-family: Regular;
    font-weight: 400;
    font-size: 0.13rem;
    line-height: 0.14rem;
    color: #6e7687;
  }
  .text {
    font-family: Medium;
    font-weight: 500;
    font-size: 0.24rem;
    line-height: 0.29rem;
    color: #0059da;
    margin-left: 0.08rem;
  }
}
</style>
